import React from 'react'
import PropTypes from 'prop-types'
import { Select, MenuItem } from '@material-ui/core'
import Item from '../../utilities/Data/Item'
import Thing from '../../utilities/Data/Thing'
import connectPropTypes from '../../utilities/connectPropTypes'
import colourSchema from '../../utilities/Data/Colour'
import styles from './Colour.icss'

class Colour extends React.Component {
	handleColourChangeBinder(itemEntity) {
		return e => this.props.appRedirect(Thing.href({ ...itemEntity, colour: { colourName: e.target.value } }))
	}

	render() {
		const { handleColourChange, itemEntity } = this.props
		let { colourNames, colourName } = this.props

		colourName = colourName || (itemEntity && itemEntity.colourName) || Item.allColours
		colourNames = colourNames || (itemEntity && itemEntity.colourNames)

		const canonicalColourNames = colourNames.map(col => colourSchema.canonicalName(col))
		const getOriginalColourName = canName => colourNames.reduce((acc, cn) => (colourSchema.canonicalName(cn) === canName ? cn : acc))
		const canonicalColourName = colourSchema.canonicalName(colourName)
		const hasMultipleColours = colourNames && colourNames.length > 1

		return (
			<section className={[styles.section, styles.pagePadding].join(' ')}>
				<div>
					{hasMultipleColours && (
						<Select
							classes={{ root: styles.colourSelect }}
							className={styles.selectBox}
							value={canonicalColourName}
							onChange={handleColourChange || this.handleColourChangeBinder(itemEntity)}
							inputProps={{
								name: 'colour',
								id: 'colour'
							}}
						>
							<MenuItem value={colourSchema.canonicalName(Item.allColours)}>{this.context.translate('Colour: All colours')}</MenuItem>
							{canonicalColourNames.map(aColourName => (
								<MenuItem
									key={`colour-${aColourName}`}
									value={aColourName}
								>
									{this.context.translate('Colour: {colourName}', { colourName: getOriginalColourName(aColourName) })}
								</MenuItem>
							))}
						</Select>
					)}
					{!hasMultipleColours && (
						<div className={styles.noMultipleColours}>
							{this.context.translate('Colour: {colourName}', {
								colourName: colourNames ? colourNames[0] : colourName
							})}
						</div>
					)}
				</div>
			</section>
		)
	}
}

Colour.contextTypes = {
	translate: PropTypes.func
}

Colour.propTypes = {
	itemEntity: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	colourNames: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	colourName: PropTypes.string,
	handleColourChange: PropTypes.func,
	appRedirect: PropTypes.func.isRequired
}

Colour.defaultProps = {
	itemEntity: {},
	colourNames: undefined,
	colourName: undefined,
	handleColourChange: undefined
}

export default connectPropTypes(Colour)



// WEBPACK FOOTER //
// ./src/components/Item/Colour.jsx